export const DROPDOWN_IDS = ['connect', 'learn', 'share'] as const;
export type DropdownId = (typeof DROPDOWN_IDS)[number];

export interface CommunityNavDropdownOption {
  hrefKey: string;
  labelKey: string;
}

export const COMMUNITY_NAV_DROPDOWN_OPTIONS: Record<
  DropdownId,
  CommunityNavDropdownOption[]
> = {
  connect: [
    {
      hrefKey:
        'marketplace.community-nav-sub-header.connect.partners-directory-link',
      labelKey:
        'marketplace.community-nav-sub-header.connect.partners-directory-label',
    },
    {
      hrefKey:
        'marketplace.community-nav-sub-header.connect.studio-league-link',
      labelKey:
        'marketplace.community-nav-sub-header.connect.studio-league-label',
    },
    {
      hrefKey:
        'marketplace.community-nav-sub-header.connect.community-forum-link',
      labelKey:
        'marketplace.community-nav-sub-header.connect.community-forum-label',
    },
  ],
  learn: [
    {
      hrefKey: 'marketplace.community-nav-sub-header.learn.tutorials-link',
      labelKey: 'marketplace.community-nav-sub-header.learn.tutorials-label',
    },
    {
      hrefKey: 'marketplace.community-nav-sub-header.learn.roadmap-link',
      labelKey: 'marketplace.community-nav-sub-header.learn.roadmap-label',
    },
    {
      hrefKey: 'marketplace.community-nav-sub-header.learn.inspiration-link',
      labelKey: 'marketplace.community-nav-sub-header.learn.inspiration-label',
    },
  ],
  share: [
    {
      hrefKey:
        'marketplace.community-nav-sub-header.share.templates-marketplace-link',
      labelKey:
        'marketplace.community-nav-sub-header.share.templates-marketplace-label',
    },
    {
      hrefKey:
        'marketplace.community-nav-sub-header.share.sell-studio-templates-link',
      labelKey:
        'marketplace.community-nav-sub-header.share.sell-studio-templates-label',
    },
  ],
};
